// Vendor libs
// ------------------------------------

// Angular extensions
import "angular-filter";
import "angular-raven";
import "angular-marked";

import ngAria from "angular-aria";
import ngAnimate from "angular-animate";
import ngMessages from "angular-messages";
import ngSanitize from "angular-sanitize";
import ngStorage from "angular-storage";
import ngLoadingBar from "angular-loading-bar";
import ngDeviceDetector from "ng-device-detector";
import ngShowdown from "ng-showdown";

// Angular UI modules
import uiRouter from "angular-ui-router";
import uiSelect from "ui-select";
import "ui-cropper";

// UI Bootstrap components
import uibButtons from "angular-ui-bootstrap/src/buttons";
import uibCollapse from "angular-ui-bootstrap/src/collapse";
import uibDropdown from "angular-ui-bootstrap/src/dropdown";
import uibModal from "angular-ui-bootstrap/src/modal";
import uiProgressbar from "angular-ui-bootstrap/src/progressbar";
import uiTypeahead from "angular-ui-bootstrap/src/typeahead";

// fino shared modules
import ng1BankSearch from "@fino/ng1-bank-search";
import ng1Cache from "@fino/ng1-cache";
import ng1Config from "@fino/ng1-config";
import ng1Environment from "@fino/ng1-environment";
import ng1FreshdeskFaqs from "@fino/ng1-freshdesk-faqs";
import ng1Loading from "@fino/ng1-loading";
import ng1Locale from "@fino/ng1-locale";
import ng1PromiseDecorator from "@fino/ng1-promise-decorator";
import ng1Response from "@fino/ng1-response";
import ng1SignaturePad from "@fino/ng1-signature-pad";
import ng1Translation from "@fino/ng1-translation";
import ngErrorHandling from "@fino/ng1-error-handling";
import ngFloatLabel from "@fino/ng1-float-label";
import ngFormButton from "@fino/ng1-form-button";
import ngFormControl from "@fino/ng1-form-control";
import ngFormValidation from "@fino/ng1-form-validation";
import ngIcon from "@fino/ng1-icon";
import ngInputLabel from "@fino/ng1-input-label";
import ngModal from "@fino/ng1-modal";
import ngTranslate from "@fino/ng1-translate";

export default [
	"angular.filter",
	"hc.marked",
	ngAria,
	ngAnimate,
	ngMessages,
	ngSanitize,
	ngStorage,
	ngLoadingBar,
	ngDeviceDetector,
	ngShowdown.name,

	uiSelect,
	uiRouter,
	"uiCropper",
	"ngRaven",

	uibButtons,
	uibCollapse,
	uibDropdown,
	uibModal,
	uiProgressbar,
	uiTypeahead,

	ng1BankSearch,
	ng1Cache,
	ng1Config,
	ng1Environment,
	ng1PromiseDecorator,
	ng1Response,
	ng1Loading,
	ng1Locale,
	ng1Translation,
	ng1FreshdeskFaqs,
	ng1SignaturePad,
	ngTranslate,
	ngFormButton,
	ngFormControl,
	ngFormValidation,
	ngFloatLabel,
	ngInputLabel,
	ngErrorHandling,
	ngModal,
	ngIcon,
];



// WEBPACK FOOTER //
// ./src/app/bootstrap/dependencies.js